const baseurl = "../../assets/img/project/";
export const projects = [
  {
    projectTitle: "Hush - Android Application",
    projectDate: "Jan '20 - Apr '20",
    projectType: "A N D R O I D",
    projectOverview:
      "Introducing Hush, an event scheduler and peer activity viewer application",
    projectDetails:
      "Did your phone ever ring when you didn't want it to? Well worry no more, We have got just the thing for you. Hush comes with a very user friendly and easy to use UI, we follow the policy of Less clicks more work. With Hush you will be able to Setup multiple profiles of Quite-Hours(one for driving, one for sleeping, one for meetings etc). Set status based on your availability, which can be viewed by your contacts. There are many more features to explore, click below to learn more",
    projectLink:
      "https://play.google.com/store/apps/details?id=org.hushapps.hush",
    projectImageName: baseurl + "1.jpg",
    username: "gauravm",
    id: 1,
    keywords: ["Android", "Firebase", "Javascript", "UX", "Java"],
  },
  {
    projectTitle: "Personal Portfolio",
    projectType: "W E B A P P",
    projectDate: "Mar '20 - May '20",
    projectOverview: "Personal portfolio website developed using react",
    projectLink: "https://deepthi-murthy.web.app",
    projectDetails:
      "This is a Personal portfolio project developed entirely using react with Javascript using components based approach. It uses redux for state management and is deployed on firebase",
    projectImageName: "./img/project/2.jpg",
    username: "gauravm",
    id: 2,
    keywords: ["React.Js", "Redux", "Firebase", "Javascript", "UX"],
  },
  {
    projectTitle: "Network Connections",
    projectType: "O S S",
    projectDate: "Aug '20 - Sept '20",
    projectOverview:
      "DotNet standard application developed for the sole purpose of simplifying fetching network details",
    projectDetails:
      "Network Connections is a DotNet standard solution that is developed for the sole purpose of reducing the effort involved to fetch the network connection details on any platform, the version 1 release supports windows platform, this solution is generic enough and can be extended to linux or OSX. It is an open source solution, so please feel free to contribute",
    projectLink: "https://www.nuget.org/packages/NetworkConnections/",
    projectImageName: "../../assets/img/project/3.jpg",
    username: "gauravm",
    id: 3,
    keywords: [
      "DotNet Standard",
      ".Net",
      "Nuget",
      "Cross Platform",
      "Open Source",
    ],
  },
  {
    projectTitle: "Smart Home Energy Management",
    projectType: "A N A L Y T I C S",
    projectDate: "Jan '29 - Apr '20",
    projectOverview:
      "Smart Home Energy Management is a system that provides monitoring energy usage in user's house and inform the user about his/her usage patterns, spikes and surges.",
    projectDetails:
      "Smart Home Energy Management System is an efficient solution to monitor energy usage in one's house and inform the user about his/her activity by analyzing the usage patterns. This solution uses complex Data Analytics and Machine Learning models to find similarities and also predict the energy usage. It also provides demographics and usage charts which highlight energy usage as well as any presence of surges/spikes which might lead to damage of electronic devices",
    projectLink: '../../assets/docs/publication_4.pdf',
    projectImageName: "../../assets/img/project/4.jpg",
    username: "gauravm",
    id: 4,
    keywords: [
      "Android",
      "Azure Blob Storage",
      "R Programming",
      "Python",
      "Data Analytics",
    ],
  },
  {
    projectTitle: "Traffic Lights Automation System",
    projectType: "E M B E D D E D",
    projectDate: "Aug '18 - Nov '18",
    projectOverview:
      "This project describes the use of wireless communications for relieving ambulance from traffic congestion in urban areas.",
    projectDetails:
      "Traffic lights management system is a solution to a real time pressing problem faced by emergency vehicles such as Ambulance/Fire Engines/Police Vehicles. This solution removes the waiting period for such vehicles in traffic areas. It provides a simple yet efficient solution to override the regular traffic lights system just for these vehicles in emergency situations. This project is simulates a traffic situation and provides a override remote to access the traffic lights system remotely",
    projectLink: "../../assets/docs/publication_5.pdf",
    projectImageName: "../../assets/img/project/5.jpg",
    username: "gauravm",
    id: 5,
    keywords: [
      "Arduino",
      "C Programming",
      "Embedded Systems",
      "Atmega8, Uno",
      "Micro Controllers",
    ],
  },
];
export const workHistory = [
  {
    workTitle: "Software Engineer",
    organisation: "Bella&Bona",
    details:
      "Working as a full stack developer alongside a team of agile developers, designing and implementing the entire e-commerce web app for Bella&Bona",
    date: "Oct '20 - Present",

    id: 1,
  },
  {
    workTitle: "Associate Software Developer",
    organisation: "Betsol",
    details:
      "Worked alongside a team of .Net Developers to develop and release a desktop application to migrate user's data across two PCs, the applications is estimated to serve close to a 40million consumers worldwide",
    date: "Jul '19 - Sept '20",

    id: 2,
  },
  {
    workTitle: "Software Developer Intern",
    organisation: "Betsol",
    details:
      "Developed and deployed a Identity Microservice using Springboot on Microsoft AD",
    date: "Jan '19 - Mar '19",

    id: 3,
  },
  {
    workTitle: "Software Developer Intern",
    organisation: "Adarshana Technology Solutions Pvt Ltd",
    details:
      "Worked as an Android Developer during the initial period of the internship, later half of the internship involved working on integrating in-house built smart home product with GoogleHome and Alexa",
    date: "Mar '18 - Mar '19",

    id: 4,
  },
  {
    workTitle: "Business Development Intern",
    organisation: "Tinystep",
    details:
      "Worked with the business development team to increase the revenue of the organistion using facebook marketing and google adwords",
    date: "Mar '17 - Jul '17",

    id: 5,
  },
];
export const socialMediaProviders = [
  "instagram",
  "github",
  "facebook",
  "twitter",
  "medium",
];
export const aboutme = {
  shortDesc:
    "Deeply involved in the designing, developing and maintaining software, I also develop Android applications. If you have any project in mind, Hit me up!!",
  workDesc:
    "I am always open to new opportunities, If you find my profile interesting and want to hire me, feel free to reach out to me",
  details:
    "I am a software developer, interested in taking up complex problems and turning them into a simple efficient solution. When I am not coding or pushing commits, you can find me in the ground scoring goals 😜 with a football or I'll be sketching landscapes or cartoons. Bit about my professional life, I am experienced in Product Development with a demonstrated history as a software developer in couple of start-up organisations and established firms. Skilled in C# and Java. Strong in programming and designing logic to a problem with a Bachelor of Engineering focused in Computer Science and Engineering.",
  Emailid: "madarkal.gaurav@gmail.com",
  socialMediaLinks: {
    instagram: "https://www.instagram.com/gauravmadarkal/",
    facebook: "https://www.facebook.com/gaurav.madarkal",
    dribble: "https://dribbble.com/gaurav-m",
    twitter: "https://twitter.com/gaurav_jarvis98",
    github: "https://github.com/gauravmadarkal",
    medium: "https://medium.com/@madarkal.gaurav",
  },
  techStack: [
    { title: "Android/Java", value: "100%", show: true },
    { title: ".Net/ASP.NET", value: "90%", show: true },
    { title: "React", value: "80%", show: true },
    { title: "SQL/NoSQL", value: "80%", show: false },
    { title: "Node", value: "70%", show: true },
    { title: "UX", value: "60%", show: false },
  ],
};
export const navLinks = [
  { to: "/", href: "#", title: "Home" },
  { to: "/projects", href: "#projects", title: "Projects" },
  { to: "/work", href: "#work", title: "Work" },
  { to: "/about", href: "#about", title: "About" },
  { to: "/contact", href: "#contact", title: "Contact" },
];
export const contactForm = [
  {
    label: "Name",
    multiLineInput: false,
    id: "name",
    placeholder: "Enter you name here",
    errorMsg: "C'mon, I need a valid name🤷‍♂️",
    errorMsgId: "name_error",
    required: true,
  },
  {
    label: "Email Address",
    multiLineInput: false,
    id: "email",
    placeholder: "Enter you email here",
    errorMsg: "How could you go wrong here!!!🤦‍♂️",
    errorMsgId: "email_error",
    required: true,
  },
  {
    label: "Message",
    multiLineInput: true,
    id: "message",
    placeholder: "Type your message here",
    errorMsg: "Just type something already😒",
    errorMsgId: "message_error",
    required: true,
  },
];
